import $ from 'jquery'
import DataTable from 'datatables.net'; // eslint-disable-line 

function getLengthMenu (size, context) {
    switch (size) {
        case 5: 
            return [[5, 20, 100, -1], [5, 20, 100, context.t('All')]];
        case 10: 
            return [[10, 50, 100, -1], [10, 50, 100, context.t('All')]];
        default:
            return [[5, 20, 100, -1], [5, 20, 100, context.t('All')]];
    }
}

function helperDataTable (classIdTable, lengthMenu, context) {
        
    $(classIdTable).DataTable({
        "ordering": false,
        "destroy": true,
        "lengthMenu": getLengthMenu(lengthMenu, context),
        "columnDefs": [
            {
            targets: [ 0 ],
                className: 'mdl-data-table__cell--non-numeric'
            }
        ],
        "language": {
             "sProcessing":     context.t("Processing..."),
             "sLengthMenu":     context.t("Show _MENU_ entries"),
             "sZeroRecords":    context.t("No matching records found"),
             "sEmptyTable":     context.t("No data available in table"),
             "sInfo":           context.t("Showing _START_ to _END_ of _TOTAL_ entries"),
             "sInfoEmpty":      context.t("Showing 0 to 0 of 0 entries"),
             "sInfoFiltered":   context.t("(filtered from _MAX_ total entries)"),
             "sInfoPostFix":    "",
             "sSearch":         context.t("Search"),
             "sUrl":            "",
             "sInfoThousands":  ",",
             "sLoadingRecords": context.t("Loading"),
             "oPaginate": {
                 "sFirst":    context.t("First"),
                 "sLast":     context.t("Last"),
                 "sNext":     context.t("Next"),
                 "sPrevious": context.t("Previous")
             },
             "oAria": {
                 "sSortAscending":  context.t(": activate to sort column ascending"),
                 "sSortDescending": context.t(": activate to sort column descending")
             }
        }

    });
}

export default helperDataTable;
  